import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { loanFlowService } from '../../services/api';
import { CheckCircle, Home } from 'lucide-react';

const LoanSuccess = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    completeFlow();
  }, []);

  const completeFlow = async () => {
    try {
      const flow = await loanFlowService.getByClient(user.id);
      if (flow) {
        await loanFlowService.update(flow.id, {
          currentStep: 'success'
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleReturnHome = () => {
    navigate('/client/dashboard');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E3F2FD' }}>
      {/* Header */}
      <div className="bg-white border-b border-gray-200 py-4 px-8">
        <div className="text-2xl font-bold">
          <span style={{ color: '#8B5CF6' }}>S2</span>
          <span className="text-gray-700">finco</span>
        </div>
      </div>

      {/* Banner */}
      <div className="bg-gray-800 text-white text-center py-2 text-sm">
        Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="p-12 bg-white shadow-xl text-center">
          <div className="mb-8">
            <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-16 w-16 text-green-600" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              🎉 Félicitations !
            </h1>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Votre dossier est finalisé
            </h2>
            <p className="text-gray-600 text-lg">
              Votre demande de crédit a été transmise avec succès
            </p>
          </div>

          <div className="bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-lg mb-8">
            <h3 className="font-semibold text-gray-900 mb-3">Prochaines étapes</h3>
            <div className="space-y-3 text-left">
              <div className="flex items-start space-x-3">
                <span className="text-green-600 font-bold">✓</span>
                <p className="text-sm text-gray-700">Votre dossier est en cours d'analyse par nos équipes</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-green-600 font-bold">✓</span>
                <p className="text-sm text-gray-700">Vous recevrez une réponse automatique dans les 5 minutes</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-green-600 font-bold">✓</span>
                <p className="text-sm text-gray-700">Les fonds seront versés sous 8 jours maximum en cas d'acceptation</p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-purple-200 p-6 rounded-lg mb-8">
            <p className="text-sm text-gray-700">
              📧 Un email de confirmation vous a été envoyé à <strong>{user?.email}</strong>
            </p>
          </div>

          <Button
            onClick={handleReturnHome}
            size="lg"
            className="text-white font-medium px-12 py-6 text-base"
            style={{ backgroundColor: '#8B5CF6' }}
          >
            <Home className="h-5 w-5 mr-2" />
            Revenir à votre espace client
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default LoanSuccess;
